import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'searchTruncate'
})
export class SearchTruncatePipe implements PipeTransform {
  public transform(value: string, search: string): string {
    if (value && search) {
      let index = value.toLowerCase().indexOf(search.toLowerCase());
      if (index === -1) {
        return `${value.substring(0, 150).trim()}${value.length > 150 ? '...' : ''}`;
      }
      let result = '';
      if (index > 75 - search.length / 2) {
        result += '...';
      }
      result += `${value
        .substring(index - 75 - search.length / 2 < 0 ? 0 : index - 75 - search.length / 2, 150)
        .trim()}`;
      if (index + 75 - search.length / 2 > value.length && value.length > 150) {
        result += '...';
      }
      return result;
    }
    return '';
  }
}
